import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloneFormComponent } from 'src/app/custom-forms/components/clone-form/clone-form.component';
import { DEFAULT_DATE_TIME_SECONDS_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-forms-library-template',
  templateUrl: './forms-library-template.component.html',
  styleUrls: ['./forms-library-template.component.scss'],
  standalone: false,
})
export class FormsLibraryTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  dateFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;

  constructor(private dialog: MatDialog) {}

  openCloneDialog(): void {
    this.dialog.open(CloneFormComponent, {
      width: '400px',
      panelClass: 'mobile-sizing-for-mat-dialogs',
      data: { customFormId: this.element.id },
    });
  }
}
